import React from "react";

// Import the row component for rendering individual table rows
import Tr from "./Tr";

// The Table component displays a list of records in a tabular format
export default function Table({
  data, // Array of data objects to be displayed in the table
  onEdit, // Callback function for editing a record
  onDelete, // Callback function for deleting a record
  isAllowedToEditOrDelete, // Boolean indicating if editing/deleting is allowed
}) {
  return (
    <div className="form-container">
      <table className="table">
        <thead>
          <tr>
            {/* Table headers */}
            <th className="ps-5">
              <span className="extra_space_3">Name</span>
            </th>
            <th className="col-numeric-date">Display Order</th>
            <th className="col-options">Options</th>
          </tr>
        </thead>

        <tbody>
          {/* Check if there is any data to display */}
          {data.length === 0 ? (
            <tr>
              {/* Display a message if no data is found */}
              <td colSpan={3}>No data found....</td>
            </tr>
          ) : (
            // Map through the data array and render a row for each item
            data.map((d, index) => (
              <Tr
                key={index} // Unique key for each row
                id={d.approved_name_id} // ID of the approved name
                approved_name={d.approved_name} // Approved name text
                art_pack_id={d.art_pack_id} // Art pack ID
                display_order={d.display_order} // Display order value
                onEdit={onEdit} // Pass down the edit callback
                onDelete={onDelete} // Pass down the delete callback
                isAllowedToEditOrDelete={isAllowedToEditOrDelete} // Pass edit/delete permissions
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
